import React, { useMemo } from 'react';
import AsyncEmoji from './emoji';
/**
 * Takes an object of template variables and returns a map of
 * template variable keys to React elements
 */
export function useFormattedTextValues() {
  var templateVariables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cloudId = arguments.length > 1 ? arguments[1] : undefined;
  // process template variables and build emoji map
  var messageValues = useMemo(function () {
    return Object.keys(templateVariables).reduce(function (values, key) {
      var variable = templateVariables[key];
      if (typeof variable === 'string' || typeof variable === 'number') {
        values[key] = variable;
        return values;
      }
      switch (variable.type) {
        case 'EMOJI':
          values[key] = /*#__PURE__*/React.createElement(AsyncEmoji, {
            id: variable.id,
            fallback: variable.fallback,
            cloudId: cloudId
          });
          break;
        default:
          // unicode replacement character
          values[key] = '�';
          break;
      }
      return values;
    }, {});
  }, [templateVariables, cloudId]);
  return messageValues;
}